const template = (data, extraClasses = '') => `
<div class="alert alert--error u-mv ${extraClasses}">
    <svg width="20" height="20" class="alert__icon">
        <use xlink:href="/application/themes/rawnet/app/images/sprite.svg#error"></use>
    </svg>
    ${data}
</div>
`
export default template
